export default (color, processingStatus, customerId, savedPhotos, status, customerFlagged) => ({
    color,
    customerFlagged,
    processingStatus,
    sendPictures() {
        if( !savedPhotos ) {
            return;
        }

        this.$dispatch('customers::send-pictures', [status, customerId, this.customerFlagged]);
    }
});
